/* tslint:disable */
/* eslint-disable */
/* @relayHash d34edb8668510f580205c7f5feeb921f */

import { ConcreteRequest } from "relay-runtime";
export type DelegateProfilePage_RequestBackgroundCheckMutationVariables = {
    delegateUUID: string;
    email?: string | null;
    requestDBS: boolean;
    isRenewal?: boolean | null;
    idExpiry?: string | null;
};
export type DelegateProfilePage_RequestBackgroundCheckMutationResponse = {
    readonly requestBackgroundCheck: boolean;
};
export type DelegateProfilePage_RequestBackgroundCheckMutation = {
    readonly response: DelegateProfilePage_RequestBackgroundCheckMutationResponse;
    readonly variables: DelegateProfilePage_RequestBackgroundCheckMutationVariables;
};



/*
mutation DelegateProfilePage_RequestBackgroundCheckMutation(
  $delegateUUID: UUID!
  $email: String
  $requestDBS: Boolean!
  $isRenewal: Boolean
  $idExpiry: Time
) {
  requestBackgroundCheck(delegateUUID: $delegateUUID, requestDBS: $requestDBS, email: $email, isRenewal: $isRenewal, idExpiryDate: $idExpiry)
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "delegateUUID",
            "type": "UUID!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "email",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "requestDBS",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "isRenewal",
            "type": "Boolean",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "idExpiry",
            "type": "Time",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "requestBackgroundCheck",
            "args": [
                {
                    "kind": "Variable",
                    "name": "delegateUUID",
                    "variableName": "delegateUUID"
                },
                {
                    "kind": "Variable",
                    "name": "email",
                    "variableName": "email"
                },
                {
                    "kind": "Variable",
                    "name": "idExpiryDate",
                    "variableName": "idExpiry"
                },
                {
                    "kind": "Variable",
                    "name": "isRenewal",
                    "variableName": "isRenewal"
                },
                {
                    "kind": "Variable",
                    "name": "requestDBS",
                    "variableName": "requestDBS"
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "DelegateProfilePage_RequestBackgroundCheckMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "DelegateProfilePage_RequestBackgroundCheckMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "DelegateProfilePage_RequestBackgroundCheckMutation",
            "id": null,
            "text": "mutation DelegateProfilePage_RequestBackgroundCheckMutation(\n  $delegateUUID: UUID!\n  $email: String\n  $requestDBS: Boolean!\n  $isRenewal: Boolean\n  $idExpiry: Time\n) {\n  requestBackgroundCheck(delegateUUID: $delegateUUID, requestDBS: $requestDBS, email: $email, isRenewal: $isRenewal, idExpiryDate: $idExpiry)\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '51e84f8472dbb7758595d4e247edbd16';
export default node;
